import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 33.75 45">
  <path d="M15.141,4.717a2.11,2.11,0,0,0,3.469,0C31.38-13.8,33.75-15.7,33.75-22.5A16.875,16.875,0,0,0,16.875-39.375,16.875,16.875,0,0,0,0-22.5C0-15.7,2.37-13.8,15.141,4.717Z" transform="translate(0 39.375)"/>
</svg>
  )
